export const EMBED_VIDEO_EXPORT_URL_PATTERN = /\/api\/v1\/embed-video\/[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}/i;
export const LOGIN_URL_PATTERN = /\/api\/v\d+\/auth\/sparemin/i;
export const LOGIN_STATUS_CODES = [400, 422];
export const ERROR_MESSAGES_TO_BE_FILTERED = [
  'Request has been terminated',
  'ResizeObserver loop limit exceeded',
];
